'use strict'
import serviceBase from './serviceBase'

const destinationService = {
   
    conference:  (data) =>  serviceBase.post('/conference',data)

}
export default destinationService